import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { friendsAPI } from '../services/api';

interface NotificationProps {
  message: string;
  type: 'success' | 'error' | 'info';
  onClose: () => void;
  autoClose?: boolean;
  duration?: number;
}

const Notification: React.FC<NotificationProps> = ({ 
  message, 
  type, 
  onClose, 
  autoClose = true, 
  duration = 5000 
}) => {
  useEffect(() => {
    if (autoClose) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [autoClose, duration, onClose]);

  const getIcon = () => {
    switch (type) {
      case 'success': return '✓';
      case 'error': return '✕';
      case 'info': return 'ℹ';
      default: return '•';
    }
  };

  const getBackgroundColor = () => {
    switch (type) {
      case 'success': return 'rgba(40, 167, 69, 0.1)';
      case 'error': return 'rgba(220, 53, 69, 0.1)';
      case 'info': return 'rgba(0, 123, 255, 0.1)';
      default: return 'rgba(255, 255, 255, 0.1)';
    }
  };

  const getBorderColor = () => {
    switch (type) {
      case 'success': return 'rgba(40, 167, 69, 0.3)';
      case 'error': return 'rgba(220, 53, 69, 0.3)';
      case 'info': return 'rgba(0, 123, 255, 0.3)';
      default: return 'rgba(255, 255, 255, 0.3)';
    }
  };

  const getTextColor = () => {
    switch (type) {
      case 'success': return '#28a745';
      case 'error': return '#ff6b6b';
      case 'info': return '#007bff';
      default: return '#fff';
    }
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: '20px',
        right: '20px',
        background: getBackgroundColor(),
        border: `1px solid ${getBorderColor()}`,
        borderRadius: '8px',
        padding: '12px 16px',
        color: getTextColor(),
        backdropFilter: 'blur(10px)',
        zIndex: 1000,
        minWidth: '300px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
        animation: 'slideIn 0.3s ease-out',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ marginRight: '8px', fontSize: '16px' }}>{getIcon()}</span>
          <span>{message}</span>
        </div>
        <button
          onClick={onClose}
          style={{
            background: 'none',
            border: 'none',
            color: getTextColor(),
            cursor: 'pointer',
            fontSize: '18px',
            marginLeft: '12px',
            padding: '0',
            width: '20px',
            height: '20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          ×
        </button>
      </div>
      <style>{`
        @keyframes slideIn {
          from {
            transform: translateX(100%);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default Notification; 